document.addEventListener('DOMContentLoaded', function() {
    const gummiesProduct = document.querySelector('.gummies-product');
    
    if (gummiesProduct) {
        const swatchInputs = gummiesProduct.querySelectorAll('.swatch input[type="radio"], .swatch input[type="checkbox"]');
        const targetInput = gummiesProduct.querySelector('input[data-handle="3-pack"]');
        
        if (targetInput) {
            // First, remove "checked" from all inputs inside .swatch
            swatchInputs.forEach(input => {
                input.checked = false;
            });

            // Set "checked" on the 3-pack input
            targetInput.checked = true;
            
            // Perform click on the 3-pack input
            targetInput.click();
        }
    }
});
